import React from 'react'

// components
import InputField from '../../InputField/InputField.component'
import SelectField from '../../SelectField/SelectField.component'

import { Grid, Paper, IconButton, Typography } from '@mui/material'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'

const reasonOptions = [
    { label: 'Returning a Rental', value: 'R'},
    { label: 'Damaged', value: 'D'},
    { label: 'Scrapped', value: 'S'},
    { label: 'Other', value: 'O'}
    // { label: 'Cycle Count - Missing Parts', value: 'C'}
]

export default function InventoryAdjustmentEquipmentInput({ title, subTitle, prefix, handleChange, handleSelectChange, amount, reason, handleRemove, errors }) {

    return (<Grid container spacing={4}>
        <Grid item xs={1}>
            <IconButton onClick={handleRemove}>
                <RemoveCircleIcon color='error' />
            </IconButton>
        </Grid>
        <Grid item xs={11}>
            <Paper variant='outlined' sx={{ padding: 2, paddingBottom: 0, marginBottom: 2}}>
                <Grid container sx={{ marginBottom: 4 }}>
                    <Grid item xs={8}><Typography variant="h6">{title}</Typography></Grid>
                    <Grid item xs={4} textAlign={'right'}>{subTitle}</Grid>
                </Grid>

                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <InputField 
                            id={`${prefix}.amount`}
                            type="text"
                            placeholder='Adjustment Amount (+/-)'
                            onChange={handleChange}
                            value={amount}
                            isValid={errors['amount']}
                        />
                        </Grid>
                    <Grid item xs={6}>
                        <SelectField
                            id={'reason'}
                            placeholder={'Reason'}
                            options={reasonOptions}
                            handleChange={handleSelectChange}
                            value={reason}
                            isValid={errors['reason']}
                        />
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    </Grid>)
}